export default "__VITE_ASSET__BsOWurxR__"